var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn text-uppercase btn-sm btn-success btn-block",attrs:{"type":"button"},on:{"click":function($event){return _vm.reset()}}},[_c('li',{staticClass:"fa fa-bolt"}),_vm._v(" Habilitar ALERTA DE VIBRAÇÃO\n")])}
var staticRenderFns = []

export { render, staticRenderFns }